import { useCallback } from 'react';
import { useQuery } from 'react-query';

export type Bank = {
    name: string;
    code: string;
    ussd: string;
    logo: string;
    slug: string;
    id: number;
};

const fetchBanks = async (): Promise<Bank[]> => {
    const response = await fetch('https://nigerianbanks.xyz');
    if (!response.ok) {
        throw new Error('Failed to fetch banks.');
    }
    return await response.json();
};

export const useBankLogos = () => {
    const { data: banks = [], isLoading: loading, isError, error } = useQuery<
        Bank[],
        Error
    >(['bank-logos'], fetchBanks, {
        retry: 1
    });

    const getBankByCode = useCallback(
        (code: string) => {
            return banks.find((bank) => bank.code === code) || null;
        },
        [banks]
    );

    return {
        banks,
        loading,
        error: isError ? error?.message : null,
        getBankByCode
    };
};
